import {
  createPassenger,
  deletePassenger,
  getAllPassengers,
  getPassenger,
  updatePassenger
} from "./chunk-UWUX3UL5.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/flights/passengers.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
var useCreatePassenger = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPassenger,
    onSuccess: (newPassenger) => {
      queryClient.setQueriesData(
        {
          queryKey: ["getAllPassengers"]
        },
        (oldData) => {
          return [...oldData, newPassenger];
        }
      );
    }
  });
};
var useUpdatePassenger = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePassenger,
    onSuccess: (newPassenger) => {
      queryClient.setQueriesData(
        {
          queryKey: ["getAllPassengers"]
        },
        (oldData) => {
          return oldData == null ? void 0 : oldData.map(
            (passenger) => passenger.id === newPassenger.id ? newPassenger : passenger
          );
        }
      );
      queryClient.setQueryData(["getPassenger", newPassenger.id], newPassenger);
    }
  });
};
var useDeletePassenger = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePassenger,
    onSuccess: (_, deletedPassengerId) => {
      queryClient.setQueriesData(
        {
          queryKey: ["getAllPassengers"]
        },
        (oldData) => {
          return oldData == null ? void 0 : oldData.filter(
            (passenger) => passenger.id !== deletedPassengerId
          );
        }
      );
      queryClient.setQueryData(["getPassenger", deletedPassengerId], null);
    }
  });
};
var useGetPassenger = (props) => {
  return useQuery({
    queryFn: () => getPassenger(props),
    queryKey: ["getPassenger", props],
    enabled: !!props
  });
};
var useGetAllPassengers = (props, options) => {
  return useQuery(__spreadValues({
    queryFn: () => getAllPassengers(props),
    queryKey: ["getAllPassengers", props]
  }, options));
};

export {
  useCreatePassenger,
  useUpdatePassenger,
  useDeletePassenger,
  useGetPassenger,
  useGetAllPassengers
};
//# sourceMappingURL=chunk-H7Q4YDSJ.mjs.map